import client from '../../../config/api';
import {
  LOCAL_APPEND_CHANGELOG_PAGE,
  LOCAL_RESET_CHANGELOG,
} from '../mutations/mutationTypes';

const PAGE_SIZE = 50;

export default {
  async GET_JOB_CHANGELOG(
    { commit, state },
    {
      jobId,
      reset = false,
      entityType = null,
      action = null,
      search = null,
      view = null,
    } = {}
  ) {
    const params = { limit: PAGE_SIZE };
    if (!reset && state.lastEvaluatedKey) {
      params.startKey = state.lastEvaluatedKey;
    }
    if (entityType) {
      params.entityType = entityType;
    }
    if (action) {
      params.action = action;
    }
    if (view) {
      params.view = view;
    }
    if (search && String(search).trim()) {
      params.search = String(search).trim();
    }

    const result = await client.get(`/job/${jobId}/changelog`, { params });

    if (!result || !result.data) {
      return null;
    }

    commit(LOCAL_APPEND_CHANGELOG_PAGE, {
      items: result.data.items || [],
      lastEvaluatedKey: result.data.lastEvaluatedKey,
      reset,
    });

    return result.data;
  },

  async EXPORT_JOB_CHANGELOG(
    _context,
    { jobId, entityType = null, action = null, search = null, view = null } = {}
  ) {
    const params = {};
    if (entityType) {
      params.entityType = entityType;
    }
    if (action) {
      params.action = action;
    }
    if (view) {
      params.view = view;
    }
    if (search && String(search).trim()) {
      params.search = String(search).trim();
    }

    const result = await client.get(`/job/${jobId}/changelog/export`, {
      params,
    });

    if (!result || !result.data) {
      return { items: [], count: 0, truncated: false };
    }

    return {
      items: result.data.items || [],
      count: result.data.count || 0,
      truncated: Boolean(result.data.truncated),
    };
  },

  RESET_JOB_CHANGELOG({ commit }) {
    commit(LOCAL_RESET_CHANGELOG);
  },

  async POST_JOB_HISTORY_NOTE(_context, { jobId, text, tool } = {}) {
    const params = {};
    if (tool) {
      params.tool = tool;
    }
    const result = await client.post(
      `/job/${jobId}/changelog/note`,
      { text },
      { params }
    );
    return result && result.data ? result.data : null;
  },
};
